module.exports = __webpack_public_path__ + "9f252a12c1d1ed0020cb27fd310d139f.png";